'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _event = require('../../core/event');

var _event2 = _interopRequireDefault(_event);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jquery2.default.fn.dataTable.ext.buttons.insert = {
	name: 'insert',
	className: 'buttons-insert',
	text: function text(dt) {
		return dt.i18n('buttons.insert', '<i class="fa fa-plus" />&nbsp;New record');
	},
	action: function action(e, dt, node, config) {
		if (config && config.type === 'form') {
			// form
			var url = config.url;
			dt.editor().formInsert(url);
		} else {
			// inline
			dt.editor().inlineInsert();
		}

		var index = this.node().index();
		// hide insert button
		(0, _jquery2.default)(this.node()).hide();
		// add cancel & insert buttons
		if (dt.button('insertSubmit:name').length === 0) {
			dt.button().add(index, 'insertCancel');
			dt.button().add(index, 'insertSubmit');
		}
		dt.button('insertSubmit:name').node().show();
		dt.button('insertCancel:name').node().show();
	},
	key: {
		key: 'n',
		altKey: true
	}
};

_jquery2.default.fn.dataTable.ext.buttons.insertSubmit = {
	name: 'insertSubmit',
	className: 'buttons-save buttons-insert-submit',
	text: function text(dt) {
		return dt.i18n('buttons.insertSubmit', '<i class="fa fa-save" />&nbsp;Save');
	},
	init: function init() {
		this.node().hide();
	},
	action: function action(e, dt, node) {
		dt.editor().submitNewEntity(node);
	},
	key: {
		key: 's',
		altKey: true
	}
};

_jquery2.default.fn.dataTable.ext.buttons.insertCancel = {
	name: 'insertCancel',
	className: 'buttons-cancel buttons-insert-cancel',
	text: function text(dt) {
		return dt.i18n('buttons.insertCancel', '<i class="fa fa-cancel" />&nbsp;Cancel');
	},
	init: function init() {
		this.node().hide();
	},
	action: function action(e, dt) {
		dt.editor().cancelInsert();
	}
};

_event2.default.on('linksoft.datatables.insertCancel', function (e) {
	e.api.button('insertCancel:name').node().hide();
	e.api.button('insertSubmit:name').node().hide();
	e.api.button('insert:name').node().show();
});

_event2.default.on('linksoft.datatables.inserting', function (e) {
	e.api.button('insertSubmit:name').disable();
});

_event2.default.on('linksoft.datatables.inserted', function (e) {
	var dt = e.api;
	e.api.button('insertSubmit:name').enable();

	if (typeof e.data === 'string') {
		// form re-rendered, keep it open
		setTimeout(function () {
			dt.editor()._adjustInsertRowHeight();
		}, 50);
	} else {
		dt.button('insertSubmit:name').node().hide();
		dt.button('insertCancel:name').node().hide();
		dt.button('insert:name').node().show();
		// reload and highlight new record
		var newEntity = {};
		newEntity[dt.primaryKey()] = e.data;
		var newRowId = dt.rowId(newEntity);
		dt.ajax.reload(function () {
			newRowId && setTimeout(function () {
				(0, _jquery2.default)('#' + newRowId).addClass('just-inserted');
				setTimeout(function () {
					(0, _jquery2.default)('#' + newRowId).removeClass('just-inserted');
				}, 750);
			}, 50);
		}, false);
	}
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/buttons/insert.js
// module id = 980
// module chunks = 0